export function getNSITnvedByIDsList(state) {
  return state.nsiTnvedByIDs;
}

export function getSearchNSITnved(state) {
  return state.nsiTnvedSearch;
}
